import { useEffect, useState } from 'react'
import { Button, Form, Input, Modal, message } from 'antd'
import Api from '../../api'
import { verificationCodeIntervalTime } from '../../setting'
import { getApiCode, getApiMessage, getApiPayload, getErrorCode } from '../../utils/wechatQr'
import './index.scss'

const PHONE_PATTERN = /^1\d{10}$/

export default function WechatPhoneBindModal({ visible, pollToken, onSuccess, onCancel, requestOptions }) {
  const [form] = Form.useForm()
  const [countdown, setCountdown] = useState(0)
  const [sending, setSending] = useState(false)
  const [binding, setBinding] = useState(false)

  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setCountdown(0)
    }
  }, [visible, form])

  useEffect(() => {
    if (!countdown) return undefined
    const timer = window.setTimeout(() => setCountdown(countdown - 1), 1000)
    return () => window.clearTimeout(timer)
  }, [countdown])

  const sendCode = async () => {
    if (sending || countdown) return
    try {
      const { phone } = await form.validateFields(['phone'])
      setSending(true)
      const response = await Api.getVerifyCode({ phone, type: 3 }, requestOptions)
      if (getApiCode(response) === 0) {
        setCountdown(verificationCodeIntervalTime)
      } else {
        message.error(getApiMessage(response) || '验证码发送失败')
      }
    } catch (error) {
      if (!error?.errorFields) message.error('验证码发送失败，请重试')
    } finally {
      setSending(false)
    }
  }

  const bind = async () => {
    if (binding || !pollToken) return
    try {
      const { phone, verify_code } = await form.validateFields()
      setBinding(true)
      const response = await Api.bindWeChat({ poll_token: pollToken, phone, verify_code }, requestOptions)
      const ticket = getApiPayload(response)?.ticket
      if (getApiCode(response) === 0 && ticket) {
        onSuccess(ticket)
      } else if (getApiCode(response) === 10129) {
        message.error('二维码已过期，请重新扫码')
        onCancel()
      } else {
        message.error(getApiMessage(response) || '绑定失败，请重试')
      }
    } catch (error) {
      if (!error?.errorFields) {
        if (getErrorCode(error) === 10129) {
          message.error('二维码已过期，请重新扫码')
          onCancel()
        } else {
          message.error('绑定失败，请重试')
        }
      }
    } finally {
      setBinding(false)
    }
  }

  return (
    <Modal
      title={null}
      keyboard={false}
      maskClosable={false}
      visible={visible}
      centered
      footer={null}
      closable={!binding}
      onCancel={() => { if (!binding) onCancel() }}
      wrapClassName="wechat-phone-bind-modal"
    >
      <div className="bindDiv">绑定手机号</div>
      <div className="tipsDiv">该微信为首次登录，需绑定手机号提高账号安全</div>
      <Form form={form} colon={false} autoComplete="off" className="bindModelForm">
        <Form.Item label="手机号" name="phone" rules={[
          { required: true, message: '手机号不能为空' },
          { pattern: PHONE_PATTERN, message: '手机号格式不对' },
        ]}>
          <Input placeholder="请输入手机号" />
        </Form.Item>
        <Form.Item label="验证码" required>
          <div className="codeRow">
            <Form.Item name="verify_code" noStyle rules={[
              { required: true, message: '验证码不能为空' },
              { pattern: /^\d{6}$/, message: '验证码格式不对' },
            ]}>
              <Input placeholder="请输入验证码" />
            </Form.Item>
            <Button className="verificationCodeBtn" onClick={sendCode} disabled={Boolean(countdown)} loading={sending}>
              {countdown ? `${countdown}s后重试` : '获取验证码'}
            </Button>
          </div>
        </Form.Item>
      </Form>
      <Button className="upBtn" onClick={bind} loading={binding} disabled={!pollToken}>绑定</Button>
    </Modal>
  )
}
